export default "/images/byblos_bank.png?00b8dca544f62bc8e2843d132a949dbc";